var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "../../styles/ResultGrid.module.scss";
import GuessCell from "./GuessCell";
import Cell from "./Cell";
var COLS = [0, 1, 2, 3, 4];
var Row = function (_a) {
    var guesses = _a.guesses, row = _a.row, answerCard = _a.answerCard;
    return (_jsxs("div", __assign({ className: styles.rowContainer }, { children: [guesses.length > row && _jsx(GuessCell, { guessCard: guesses[row] }, void 0), COLS.map(function (col) { return (_jsx(Cell, { col: col, guessCard: guesses.length > row ? guesses[row] : undefined, answerCard: answerCard }, col)); })] }), void 0));
};
export default Row;
